import * as React from 'react';

import {Select} from 'shells/select/select';

type StatusOption = {
    id: string;
    label: string;
};

const STATUS_OPTION_ALL: StatusOption = {
    id: 'all',
    label: 'All activities',
};
const STATUS_OPTION_LOGGED: StatusOption = {
    id: 'logged',
    label: 'Logged activities',
};
const STATUS_OPTION_UNLOGGED: StatusOption = {
    id: 'unlogged',
    label: 'Unlogged activities',
};

const STATUS_OPTIONS: StatusOption[] = [
    STATUS_OPTION_ALL,
    STATUS_OPTION_LOGGED,
    STATUS_OPTION_UNLOGGED,
];

type Props = {
    currentFilter: string | null | undefined;
    onFilterSubmit: (filterObj: {status: string}) => void;
};

export function ActivityReportStatusFilter(props: Props) {
    const selected =
        STATUS_OPTIONS.find((option) => option.id === props.currentFilter) || STATUS_OPTION_ALL;

    // @ts-expect-error
    const handleChange = (option) => {
        if (option.id === STATUS_OPTION_ALL.id || !option.id) {
            props.onFilterSubmit({status: ''});
        } else {
            props.onFilterSubmit({status: option.id});
        }
    };

    return (
        <Select
            // @ts-expect-error
            size='large'
            value={selected}
            prefix='Log status: '
            labelKey='label'
            selectValues={STATUS_OPTIONS}
            styleOptions={{filled: true, color: 'blue'}}
            onChange={handleChange}
        />
    );
}
